import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'vi-overlay-progress-bar',
  templateUrl: 'overlay-progress-bar.component.html',
  styleUrls: ['overlay-progress-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ViOverlayProgressBarComponent {
  @Input() mode: 'indeterminate' | 'determinate' | 'buffer' | 'query' = 'indeterminate';
  @Input() value: number;
}
